import listActions from 'src/modules/planificacion/list/planificacionListActions';
import PlanificacionService from 'src/modules/planificacion/planificacionService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/history';
import Message from 'src/view/shared/message';

const prefix = 'PLANIFICACION_DESTROY';

const planificacionDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id, deleted: any = null) => async (dispatch) => {
    try {
      dispatch({
        type: planificacionDestroyActions.DESTROY_STARTED,
      });

      await PlanificacionService.destroyAll([id]);

      dispatch({
        type: planificacionDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(
        i18n('entities.planificacion.destroy.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());

      if(deleted) {
        deleted(id);
      } else{
        getHistory().push('/planificacion');
      }
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: planificacionDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: planificacionDestroyActions.DESTROY_ALL_STARTED,
      });

      await PlanificacionService.destroyAll(ids);

      dispatch({
        type: planificacionDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doClearAllSelected());
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.planificacion.destroyAll.success'),
      );

      getHistory().push('/planificacion');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: planificacionDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default planificacionDestroyActions;
